module.exports = __webpack_public_path__ + "img/chaBing6.58e17c57.png";